import styled from "styled-components";
import miniIcon from '../../assets/images/16@2x.webp'
import { Link } from 'react-router-dom'

export const TitleContent = styled.div`
    margin-top: 10px;
    margin-bottom: 12px;
    display: flex;
    justify-content: space-between;
`

export const ContentLeft = styled.div`
    width: 664px;
    display: flex;
    align-items: center;
`

export const Trending = styled.ul`
    display: flex;
    list-style: none;
`

export const TrendingItem = styled.li`
    position: relative;
    margin-right: 4px;

    &:first-child{
        margin-left: 23px;
    }

    &:first-child:before {
        display: block;
        background: url(${miniIcon});
        background-repeat: no-repeat;
        background-size: 16px auto;
        background-position: 0 -51px;
        width: 16px;
        height: 9px;
        content: '';
        position: absolute;
        left: -22px;
        top: 6px;
    }
`
export const TrendingLink = styled(Link)`
    color: #222;
    font-size: 12px;
    background-color: #f1f1f1;
    padding: 4px 8px 5px;
    border-radius: 2px;
    display: block;
    text-decoration: none;
`
export const TitleNews = styled(Link)`
    text-decoration: none;
    display: block;
    color: #727b88;
    font-size: 12px;
    font-weight: bold;
    border-radius: 2px;
    background-image: linear-gradient(to top,#ededed,#fafafa);
    border: solid 1px #ededed;
    padding: 4px 8px 4px 22px;
    position: relative;
    margin-left: auto;

    &:before {
        content: '';
        width: 16px;
        height: 14px;
        background-position: -0 -65px;
        background-image: url(${miniIcon});
        display: block;
        background-repeat: no-repeat;
        background-size: 16px auto;
        position: absolute;
        top: 4px;
        left: 3px;
    }
`

export const TitleTimeHome = styled.p`
    width: 300px;
    text-align: right;
    color: #080505;
    font-size: 12px;
    margin-top: 4px;

    @media screen and (max-width: 767px) {
        width: auto;
    }

    @media screen and (max-width: 320px) {
        margin-top: 0;
    }
`
export const FocusBox = styled.div`
    width: 440px;
`
export const FocusImageLink = styled(Link)`
    text-decoration: none;
    display: block;
`

export const FocusTitle = styled(Link)`
    margin: 5px 0 3px;
    position: relative;
    display: block;
    text-decoration: none;
    color: #222;
    font-size: 18px;
    font-weight: bold;
    line-height: 21px;
`

export const FocusDesc = styled.p`
    color: #222;
    font-size: 12px;
    line-height: 14px;
    width: 425px;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    display: -webkit-box;

`

export const FocusImage = styled.img`
    width: 100%;
    height: 275px;
`

export const NewsNewBox = styled.div`
    flex: 1;
`

export const SrollPane = styled.ul`
    list-style: none;
    overflow: visible;
    overflow-y: auto;
    
    width: 100%;
    height: 351px;
    padding: 0 10px;

    &::-webkit-scrollbar {
        width: 3px;
    }

    &::-webkit-scrollbar-track {
        background: #F5F5F5;
    }


    &::-webkit-scrollbar-thumb {
        background: #D3D3D3;
    }
`
export const NewsNewItem = styled.li`
    width: 100%;
    display: inline-block;
    margin-bottom: 10px;
    position: relative;

    &:before {
        position: absolute;
        width: 4px;
        height: 4px;
        border-radius: 3px;
        background-color: #333e56;
        left: 0;
        top: 6px;
        content: '';
    }
`

export const NewsNewTitleName = styled.h2`
    display: flex;
    justify-content: space-between;
`
export const NewsNewLink = styled(Link)`
    text-decoration: none;
    color: #222;
    font-size: 13px;
    line-height: 17px;
    
    margin-left: 10px;
    font-weight: 400;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    overflow: hidden;
    display: -webkit-box;
`
export const CommentTotal = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin-left: 4px;
`

export const CommentLabel = styled.span`
    color: #d12728;
    font-size: 10px;
    font-weight: bold;
    text-align: center;
`

export const CommentIcon = styled.i`
    background-image: url(${miniIcon});
    display: block;
    background-repeat: no-repeat;
    background-size: 16px auto;
    background-position: -2px -82px;
    width: 12px;
    height: 12px;
    content: '';
`
export const FlexLayout = styled.div`
    display: flex;
`

export const ListNewsFocus = styled.ul`
    list-style: none;
    display: flex;
    margin-top: 12px;
`

export const NewsFocusItem = styled.li`

`

export const NewsFocusImageLink = styled(Link)`
    text-decoration: none;
    display: block;
`

export const NewsFocusImage = styled.img`
    width: 100%;
    height: 96px;
`

export const NewsFocusTitle = styled(Link)`
    text-decoration: none;
    margin-top: 6px;
    color: #222;
    font-size: 13px;
    font-weight: 500;
    -webkit-line-clamp: 4;
    -webkit-box-orient: vertical;
    overflow: hidden;
    display: -webkit-box;
`


export const BoxHeader = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
`

export const BoxTitle = styled(Link)`
    text-transform: uppercase;
    color: #222;
    font-size: ${({type}) => type === 'mini' ? '14px' : '18px'};
    position: relative;
    margin-left: 8px;
    font-weight: bold;
    text-decoration: none;

    &:before {
        width: 4px;
        height: 13px;
        background-color: #e32;
        content: '';
        display: block;
        position: absolute;
        left: -8px;
        top: ${({type}) => type === 'mini' ? '2px' : '4px'};
    }

    @media screen and (max-width: 768px) {
        font-size: 14px;

        &:before {
            top: 2px;
        }
    }
`




export const LatestNewBox = styled.div``

export const BorderLine = styled.span`
    width: 100%;
    border-bottom: dotted 1px #222;
    opacity: .3;
    height: 1px;
    display: block;
    position: relative;

    &:before {
        content: '';
        height: 1px;
        width: 100%;
        border-bottom: dotted 1px #222;
        position: absolute;
        top: -2px;
        left: 0;
    }

    &:after {
        content: '';
        height: 1px;
        width: 100%;
        border-bottom: dotted 1px #222;
        position: absolute;
        top: 2px;
        left: 0;
    }
`


export const TitleBoxWrap = styled.div`
    padding: 12px 0 8px;
`



